<div class="flex flex-col flex-auto w-full max-w-5xl">
    <div class="prose prose-sm !max-w-100 col-span-4">
        <h2 id="documents-heading">Þín skjöl</h2>
        <p>Hér færðu yfirlit yfir þín skjöl í Skjalamiðju LSR</p>
    </div>
    <div id="header" class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-6 px-0 !pt-1 mb-2 border-b">
        <form [formGroup]="form" #profileInNgForm="ngForm">
            <div class="flex flex-col items-center mt-4 sm:flex-row">
                <div class="flex-auto w-full sm:w-auto">
                    <mat-form-field class="fuse-mat-no-subscript w-full sm:w-[90%] mb-1">
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                        <input
                            matInput
                            [placeholder]="'Leita'"
                            formControlName="searchString"
                            (keydown.enter)="pageNumber = 0; fetchData()"
                        />
                    </mat-form-field>
                    <mat-form-field class="fuse-mat-no-subscript w-full sm:w-[90%] top-[5px]">
                        <mat-select placeholder="Tegund" formControlName="documentTypeId">
                            <mat-option [value]="'Allt'">{{ 'label_all' | translate }}</mat-option>
                            @for (type of typesDropDown; track type) {
                                <mat-option [value]="type.value">{{ type.viewValue }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="flex-auto w-full sm:w-auto mt-[10px] sm:mt-[0px]">
                    <mat-form-field class="fuse-mat-no-subscript w-full sm:w-[90%] mb-1">
                        <span class="mr-[18px]" matPrefix>Frá:</span>
                        <input
                            class="date"
                            formControlName="dateFrom"
                            matInput
                            placeholder="Dagsetning (frá)"
                            (click)="dateFrom.open()"
                            [matDatepicker]="dateFrom"
                        />
                        <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                        <mat-datepicker #dateFrom></mat-datepicker>
                        @if (this.form?.get('dateFrom')?.hasError('required')) {
                            <mat-error> Það <strong>þarf</strong> að velja dagsetningu </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="fuse-mat-no-subscript w-full sm:w-[90%] top-[5px]">
                        <span class="mr-[18px]" matPrefix>Til:</span>
                        <input
                            class="date"
                            formControlName="dateTo"
                            matInput
                            placeholder="Dagsetning (til)"
                            (click)="dateTo.open()"
                            [matDatepicker]="dateTo"
                        />
                        <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                        <mat-datepicker #dateTo></mat-datepicker>
                        @if (this.form?.get('dateTo')?.hasError('required')) {
                            <mat-error> Það <strong>þarf</strong> að velja dagsetningu </mat-error>
                        }
                    </mat-form-field>
                </div>
                <button
                    class="ml-4 min-w-[120px] w-full sm:w-auto mt-[10px] sm:mt-[0px]"
                    mat-flat-button
                    [color]="'primary'"
                    (click)="pageNumber = 0; fetchData()"
                >
                    <mat-icon [svgIcon]="'heroicons_solid:search'"></mat-icon>
                    <span class="ml-2 mr-1 block">Leita</span>
                </button>
            </div>
        </form>
    </div>
    <ng-container>
        <div>
            <div class="flex flex-wrap -m-2 mt-1.5 justify-center">
                <table mat-table matSort #sortContributionsParent="matSort" [dataSource]="dataSource" class="w-full table-expandable">
                    <ng-container matColumnDef="documentDate">
                        <th mat-header-cell *matHeaderCellDef>Dagsetning</th>
                        <td mat-cell (click)="getDocument(element)" *matCellDef="let element">
                            {{ element.documentDate | date: 'dd.MM.yyyy' }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef>Titill</th>
                        <td mat-cell (click)="getDocument(element)" *matCellDef="let element">
                            {{ element.title }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="typeTitle">
                        <th mat-header-cell *matHeaderCellDef>Tegund</th>
                        <td mat-cell (click)="getDocument(element)" *matCellDef="let element">
                            {{ element.typeTitle }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="subcategoryTitle">
                        <th mat-header-cell *matHeaderCellDef>Undirtegund</th>
                        <td mat-cell (click)="getDocument(element)" *matCellDef="let element">
                            {{ element.subcategoryTitle }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ssn">
                        <th mat-header-cell *matHeaderCellDef>Kennitala</th>
                        <td mat-cell (click)="getDocument(element)" *matCellDef="let element">
                            {{ formatSsn(element.ssn) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="details">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button (click)="viewDocumentDetails(element)" [matTooltip]="'Nánari upplýsingar'">
                                <mat-icon
                                    class="icon-size-5 text-current text-primary"
                                    [svgIcon]="'heroicons_solid:information-circle'"
                                ></mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                    <tr class="hover:opacity-70 hover:cursor-pointer" mat-row *matRowDef="let docrow; columns: tableColumns"></tr>
                </table>
            </div>
            <mat-paginator
                #paginator
                id="docPaginator"
                [length]="totalData"
                [pageSizeOptions]="pageSizes"
                [pageSize]="pageSize"
                showFirstLastButtons
            >
            </mat-paginator>
        </div>
        @if (totalData == 0 && !isLoading) {
            <div class="flex flex-col flex-auto items-center justify-center h-full p-6 sm:p-10">
                <div class="mt-12 sm:mt-24 text-4xl md:text-7xl font-extrabold tracking-tight leading-tight md:leading-none text-center">
                    {{ 'info_documents_found_count' | translate: { count: 0 } }}
                </div>
                <div class="mt-2 text-lg md:text-xl font-medium tracking-tight text-center text-secondary">
                    {{ 'info_documents_found_filter' | translate }}
                </div>
            </div>
        }
    </ng-container>
</div>
